module.exports = __webpack_public_path__ + "img/transacciones-new.96e6fb17.svg";